// TODO(BNCH-12449): Delete this file once folder items have been ported

import {SourceSummary} from 'constants/SourceConstants';
import {MakeFieldsRequired} from 'util/Types';

export function toNumberIDFolder<T extends {id: string | number; dbId: number}>(
  folder: T
): Omit<T, 'id'> & {id: number} {
  return {
    ...folder,
    id: folder.dbId,
  };
}

export function withNonNullSource<T extends {source?: SourceSummary}>(
  folder: T
): MakeFieldsRequired<T, 'source'> {
  // @ts-expect-error
  return folder;
}
